// extracted by mini-css-extract-plugin
export default {"root":"powered-by-swag-link__root___mrk7o"};